<template>
  <div v-if="show" class="modal-overlay">
    <div class="modal-dialog" @mousedown.stop @mouseup.stop @click.stop @touchstart.stop @touchend.stop>
      <div class="modal-header">
        <h3>Add Comment</h3>
        <button @click="close" class="close-btn">×</button>
      </div>
      <div class="modal-body">
        <div class="selected-text" v-if="selectedText">
          <strong>Selected text:</strong> "{{ selectedText }}"
        </div>
        <!-- <div class="mb-3" v-if="types && types.length">
          <label class="mb-1" style="display:block; font-size:13px; color:#374151;">Type</label>
          <select v-model="selectedType" class="comment-select">
            <option v-for="t in types" :key="t" :value="t">{{ labelForType(t) }}</option>
          </select>
        </div> -->
        <textarea ref="textareaRef" v-model="commentText" placeholder="Add your comment..." rows="4" class="comment-textarea"></textarea>
      </div>
      <div class="modal-footer">
        <button @click.stop="submit" class="primary-btn" :disabled="!commentText.trim()">Add Comment</button>
        <button @click.stop="close" class="secondary-btn">Cancel</button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, nextTick } from 'vue'

// Props
const props = defineProps({
  show: {
    type: Boolean,
    default: false
  },
  selectedText: {
    type: String,
    default: ''
  },
  types: {
    type: Array,
    default: () => ['comment', 'update', 'delete']
  },
  defaultType: {
    type: String,
    default: 'comment'
  }
})

// Emits
const emit = defineEmits(['close', 'submit'])

// Local state
const commentText = ref('')
const selectedType = ref(props.defaultType)
const textareaRef = ref(null)

watch(() => props.show, (newShow) => {
  if (!newShow) {
    commentText.value = ''
    selectedType.value = props.defaultType
  } else {
    nextTick(() => textareaRef.value && textareaRef.value.focus())
  }
})

const close = () => {
  emit('close')
}

const submit = () => {
  if (commentText.value.trim()) {
    emit('submit', { text: commentText.value.trim(), type: selectedType.value })
    commentText.value = ''
  }
}

function labelForType(t) {
  if (t === 'update') return '✏️ Suggestion'
  if (t === 'delete') return '🗑️ Delete'
  return '💬 Comment'
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2147483647; /* on top of any app shell */
  pointer-events: none; /* allow only dialog to receive events */
}

.modal-dialog {
  background: white;
  border-radius: 8px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  max-width: 500px;
  width: 90%;
  max-height: 80vh;
  overflow: hidden;
  pointer-events: auto; /* enable interactions */
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #dee2e6;
  background: #f8f9fa;
}

.modal-header h3 {
  margin: 0;
  font-size: 18px;
  color: #333;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #6c757d;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.close-btn:hover {
  color: #333;
}

.modal-body {
  padding: 20px;
}

.selected-text {
  background: #f8f9fa;
  padding: 12px;
  border-radius: 4px;
  margin-bottom: 16px;
  border-left: 4px solid #007bff;
  font-size: 14px;
}

.comment-select {
  width: 100%;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 8px 12px;
  font-size: 14px;
  margin-bottom: 10px;
}

.comment-textarea {
  width: 100%;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 12px;
  font-size: 14px;
  resize: vertical;
  font-family: inherit;
}

.comment-textarea:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.1);
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 20px;
  border-top: 1px solid #dee2e6;
  background: #f8f9fa;
}

.primary-btn,
.secondary-btn {
  padding: 8px 16px;
  border: 1px solid;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;
}

.primary-btn {
  background: #007bff;
  color: white;
  border-color: #007bff;
}

.primary-btn:hover:not(:disabled) {
  background: #0056b3;
  border-color: #0056b3;
}

.primary-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.secondary-btn {
  background: white;
  color: #6c757d;
  border-color: #dee2e6;
}

.secondary-btn:hover {
  background: #e9ecef;
}
</style>
